/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Charge/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import Tysiav2LedgerFilterClaims from 'DesignSystem/Svgs/Tysiav2LedgerFilterClaims/index'



/** @type {import('Simple/types.js').View} */
export default function Charge({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/TypeCell/Charge"
  
}) {
let dtColorsRed800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.800'
        })
let dtColorsRed200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.200'
        })
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="red"
 style="filled"
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<Tysiav2LedgerFilterClaims
{...childProps}
  viewPath={`${viewPath}/Tysiav2LedgerFilterClaims`}
 fill={dtColorsRed800}
 stroke={dtColorsRed200}
 width={12}
 height={12}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Charge"
/>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}